export var ErrorCodes;
(function (ErrorCodes) {
    ErrorCodes["UNKNOWN"] = "unknown";
    // Actions - SMS
    ErrorCodes["SMS_MONTHLY_LIMIT"] = "sms_monthly_limit";
    ErrorCodes["SMS_NO_NUMBER"] = "sms_no_number";
    ErrorCodes["SMS_NO_LIMIT"] = "sms_no_limit";
    // Actions - Email
    ErrorCodes["EMAIL_NO_ADDRESS"] = "email_no_address";
    // Invalid policy
    ErrorCodes["INVALID_POLICY"] = "invalid_policy";
    // Versions Errors
    ErrorCodes["OLD_VERSION"] = "old_version";
})(ErrorCodes || (ErrorCodes = {}));
export const errors = {
    [ErrorCodes.UNKNOWN]: {
        short: `Unknown error`,
        long: `An unknown error occurred - please contact support`,
    },
    // Actions - SMS
    [ErrorCodes.SMS_MONTHLY_LIMIT]: {
        short: `Monthly SMS limit reached`,
        long: `You have reached your configured monthly SMS limit. Change your limit in billing settings or contact support.`,
    },
    [ErrorCodes.SMS_NO_NUMBER]: {
        short: `No SMS number`,
        long: `This invoice contact did not have a valid mobile number to send an SMS to.`,
    },
    [ErrorCodes.SMS_NO_LIMIT]: {
        short: `No SMS found`,
        long: `No SMS limit was defined for this subscription`,
    },
};
const xeroErrors = {
    [`To update fields on a paid invoice line item, you must supply a LineItemID`]: `Cannot update an invoice with payments applied.`,
};
/** Converts old, or non human friendly errors for the UI */
export function testForErrorMap(error) {
    if (!error) {
        return error;
    }
    for (const key in xeroErrors) {
        if (error.includes(key)) {
            return xeroErrors[key];
        }
    }
    return error;
}
export function getError(type, code, error_message) {
    if (!code && !error_message) {
        return;
    }
    if (code && errors[code]) {
        return errors[code][type];
    }
    return error_message;
}
//# sourceMappingURL=errors.js.map